import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Project from "./Project";
import projects from "./project-list";

const Projects = () => ___EmotionJSX(React.Fragment, null, projects.map(project => ___EmotionJSX(Project, _extends({
  key: project.name
}, project))));

export default Projects;